//* address: "ta.https://goeuropa.ga", [folder: ta]

export const prefixURL = "https://oba.tracktrolley.com/oba-api";
export const zoomRange = 0.005;
export const api_key = "org.onebusaway.iphone";
export const fetchInterval = 60 * 1000;
export const zoomBusOnlyCircle = 11.5;
// V1 - goEuropa.ga
// export const linksObject = [
//   {
//     url: "https://sw.goeuropa.ga",
//     name: "Sweetwater",
//     variant: "primary",
//     color: "#0d6efd",
//     disabled: false,
//   },
//   {
//     url: "https://dt.goeuropa.ga",
//     name: "Doral",
//     variant: "info",
//     color: "#0dcaf0",
//     disabled: false,
//   },
//   {
//     url: "https://comb.goeuropa.ga",
//     name: "Miami Beach",
//     variant: "success",
//     color: "#198754",
//     disabled: false,
//   },
//   {
//     url: "https://mdt.goeuropa.ga",
//     name: "Miami-Dade",
//     variant: "warning",
//     color: "#ffc107",
//     disabled: false,
//   },
// ];
// V2 - tracktrolley.com
export const linksObject = [
  {
    url: "https://sweetwater.tracktrolley.com",
    name: "Sweetwater",
    variant: "primary",
    color: "#0d6efd",
    disabled: false,
  },
  {
    url: "https://doral.tracktrolley.com",
    name: "Doral",
    variant: "info",
    color: "#0dcaf0",
    disabled: false,
  },
  {
    url: "https://comb.tracktrolley.com",
    name: "Miami Beach",
    variant: "success",
    color: "#198754",
    disabled: false,
  },
  {
    url: "#",
    name: "Miami-Dade",
    variant: "warning",
    color: "#ffc107",
    disabled: true,
  },
];
